import type { Environment } from "@porsche-customer/slfinrtl-environment"

export const urlMap: Record<Environment, string> = {
	dev: "https://dealer-app-api-dev.slfinrtl.aws.porsche-preview.cloud",
	local: "https://dealer-app-api-dev.slfinrtl.aws.porsche-preview.cloud",
	preview: "https://dealer-app-api-preview.slfinrtl.aws.porsche-preview.cloud",
	prod: "https://dealer-app-api-prod.slfinrtl.aws.porsche.cloud",
}
